export default {
  title: 'Leiloeiros',
  menu: [
    {
      id: 'arrematantes',
      title: 'Leiloeiros',
      icon: 'clipboard-list-check',
      style: 'light',
      url: '/#/arrematantes/lista'
    },
    {
      id: 'relatorios',
      title: 'Relatórios',
      icon: 'user-chart',
      style: 'regular',
      url: '#'
    },
    {
      id: 'cadastros',
      title: 'Cadastros básicos',
      icon: 'cog',
      style: 'light',
      url: '/#/cadastro'
    }
  ]
}
